import { render, staticRenderFns } from "./HeaderSelector.vue?vue&type=template&id=6589fdfb&"
import script from "./HeaderSelector.vue?vue&type=script&lang=js&"
export * from "./HeaderSelector.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HeaderSelector.vue"
export default component.exports